import { useTranslation } from 'react-i18next';
import { Alert } from '@hotjar/hotsauce';
import { moment } from '@hotjar/webapp/lib/moment';

export interface ResponseLimitAlertStatelessProps {
  remaining: number;
  total: number;
  rolloverDate: Date | null;
  effectiveAskPlan: string | null;
  onAction: () => void;
}

export const ResponseLimitAlertStateless = ({
  remaining,
  total,
  rolloverDate,
  effectiveAskPlan,
  onAction,
}: ResponseLimitAlertStatelessProps): JSX.Element | null => {
  const { t } = useTranslation('feedback');
  const planMessage =
    effectiveAskPlan === 'basic' ? t('limits.reached.responses.plan_message') : '';

  if (!rolloverDate) return null;

  if (remaining <= 0)
    return (
      <Alert
        title={t('limits.reached.responses.title_no_responses')}
        kind="warning"
        onAction={onAction}
        actionText={t('limits.reached.responses.action')}
      >
        {t('limits.reached.responses.message_no_responses', {
          planMessage,
          rolloverDate: moment(rolloverDate).format('MMMM D'),
          total,
        })}
      </Alert>
    );

  return (
    <Alert
      title={t('limits.reached.responses.title_some_responses', {
        remaining,
      })}
      kind="warning"
      onAction={onAction}
      actionText={t('limits.reached.responses.action')}
    >
      {t('limits.reached.responses.message_some_responses', {
        planMessage,
        total,
      })}
    </Alert>
  );
};
